module.exports = {
    "removeButtonLabel": `Eliminar`,
    "removeDescription": `Prima Delete para eliminar a tag.`
};


//# sourceMappingURL=pt-PT.main.js.map
